// @flow

import { getLocalStorageItem } from './LocalStorage';

export function prepareSchedulerParams(params: Object, location: Object) : Object {
  if (getLocalStorageItem('scheduler') !== null) {
    return {
      emails: getLocalStorageItem('scheduler'),
    };
  }
  return {
    emails: [location.href.split('=')[1]],
  };
}

export function prepareMeetingroomParams(params: Object, { location }: Object) : Object {
  return {
    locationFilter: location.query.location || null,
  };
}



// WEBPACK FOOTER //
// ./src/js/libs/RelayRoutes.js